module.exports = __webpack_public_path__ + "img/dashboard.4c4c81bc.svg";